import React,{useEffect,useState} from 'react';
import {api} from '@/lib/api';
const filenames=new Set(['journey-room-sop.pdf','eg-source-checklists.pdf','table-standard.jpg']);
const endpoint=(url,audit=false)=>{
 const filename=(url || '').split('/').at(-1)?.split('#')[0];
 if(!filenames.has(filename))throw new Error('Source reference unavailable.');
 return audit ? `/program-audit/sources/${filename}` : `/me/duties/sources/${filename}`;
};
export function DutySourceLink({href,children,audit=false,...props}){
 const [error,setError]=useState('');
 const open=async(event)=>{
  event.preventDefault();setError('');
  const target=window.open('about:blank','_blank');
  if(target)target.opener=null;
  try{
   const result=await api.get(endpoint(href,audit),{responseType:'blob'});
   const url=URL.createObjectURL(result.data);
   if(target)target.location.href=url+(href.includes('#')?`#${href.split('#')[1]}`:'');
   else {URL.revokeObjectURL(url);throw new Error('Allow a new tab to view this source standard.');}
   window.setTimeout(()=>URL.revokeObjectURL(url),300000);
  }catch(e){target?.close();setError(e.message || 'The source standard could not be opened.');}
 };
 return <><a {...props} href={href} onClick={open}>{children}</a>{error && <p role="alert">{error}</p>}</>;
}
export function DutySourcePhoto({photo,audit=false}){
 const [url,setUrl]=useState(''),[error,setError]=useState(false);
 useEffect(()=>{let active=true,objectUrl;setUrl('');setError(false);api.get(endpoint(photo.url,audit),{responseType:'blob'}).then(result=>{objectUrl=URL.createObjectURL(result.data);if(active)setUrl(objectUrl);else URL.revokeObjectURL(objectUrl);}).catch(()=>{if(active)setError(true);});return()=>{active=false;if(objectUrl)URL.revokeObjectURL(objectUrl);};},[photo.url,audit]);
 return <figure>{url?<img src={url} alt={photo.alt}/>:<p role="status">{error?'The reference photo could not be loaded. Open the linked source standard.':'Loading reference photo…'}</p>}<figcaption>{photo.caption}</figcaption></figure>;
}
